export const UI_VERSION = 'v1.448.7'
